module.exports = __webpack_public_path__ + "img/blocked.3965cb0b.svg";